import { CSSProperties } from "react"

export const lineClampStyle = (lineClamp:number=2):CSSProperties => {
    return {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lineClamp,
        padding: '0px',
        whiteSpace: 'normal', // Pastikan teks bisa wrap
        wordBreak: 'break-word', // Hindari kata panjang menyebabkan overflow
    }
}

export const groupColors = [
  { hex: "#3b82f6", name: "blue-500", color: "white" },
  { hex: "#8b5cf6", name: "violet-500", color: "white" },
  { hex: "#84cc16", name: "lime-500", color: "black" },
  { hex: "#22c55e", name: "green-500", color: "white" },
  { hex: "#10b981", name: "emerald-500", color: "white" },
  { hex: "#f97316", name: "orange-500", color: "white" },
  { hex: "#f59e0b", name: "amber-500", color: "black" },
  { hex: "#eab308", name: "yellow-500", color: "black" },
  { hex: "#0ea5e9", name: "sky-500", color: "white" },
  { hex: "#06b6d4", name: "cyan-500", color: "white" },
  { hex: "#6366f1", name: "indigo-500", color: "white" },
  { hex: "#a855f7", name: "purple-500", color: "white" },
  { hex: "#d946ef", name: "fuchsia-500", color: "white" },
  { hex: "#ec4899", name: "pink-500", color: "white" },
  { hex: "#f43f5e", name: "rose-500", color: "white" },
  { hex: "#ef4444", name: "red-500", color: "white" },
  { hex: "#6b7280", name: "gray-500", color: "white" },
  { hex: "#64748b", name: "slate-500", color: "white" },
  { hex: "#57534e", name: "stone-500", color: "white" },
  { hex: "#44403c", name: "neutral-500", color: "white" },
  { hex: "#737373", name: "zinc-500", color: "white" },
  { hex: "#243c5a", name: "Primary", color: "white" },
  { hex: "#969696", name: "Secondary", color: "white" },
  { hex: "#1E40AF", name: "Royal Blue", color: "white" },
  { hex: "#7C3AED", name: "Violet", color: "white" },
  { hex: "#BE185D", name: "Ruby", color: "white" },
  { hex: "#059669", name: "Emerald", color: "white" },
  { hex: "#4338CA", name: "Indigo", color: "white" },
  { hex: "#9D174D", name: "Crimson", color: "white" },
  { hex: "#0369A1", name: "Ocean Blue", color: "white" },
  { hex: "#4C1D95", name: "Deep Purple", color: "white" },
  { hex: "#B91C1C", name: "Cherry Red", color: "white" },
  { hex: "#15803D", name: "Forest Green", color: "white" },
  { hex: "#6D28D9", name: "Amethyst", color: "white" },
  { hex: "#0E7490", name: "Teal", color: "white" },
  { hex: "#86198F", name: "Magenta", color: "white" },
  { hex: "#1F2937", name: "Charcoal", color: "white" },
  { hex: "#5B21B6", name: "Royal Purple", color: "white" },
]

export const dummyGroupOptions = Array.from({length: 10000}, (_, i) => ({
  label: `Group ${i + 1}`,
  options: [
    {
      value: `${i + 1}-eed2be4b-5fad-48ee-a484-f6465f9804e7`,
      label: `dummy1 / ${i + 1}`,
    },
    {
      value: `${i + 1}-832499fa-ddba-4243-a3eb-5d3afc55a9c2`,
      label: `dummy2 / ${i + 1}`,
    },
    {
      value: `${i + 1}-d1a4975f-182e-403f-b82a-c2c595628a79`,
      label: `dummy3 / ${i + 1}`,
    },
    {
      value: `${i + 1}-96b78def-99c3-433b-9fc9-435a85da01b5`,
      label: `dummy4 / ${i + 1}`,
    },
    {
      value: `${i + 1}-4f509ec7-995b-40ca-a441-c3d2247e68ca`,
      label: `dummy5 / ${i + 1}`,
    },
  ],
}))

export const dummySingleOptions = Array.from({length: 10000}, (_, i) => ({
  value: `${i + 1}-4f509ec7-995b-40ca-a441-c3d2247e68ca`,
  label: `dummy ${i + 1}`,
}))
